import { Moment } from 'moment';

export enum DirectSaleXFinancialReportType {
  noFinancialOrDivergentValue,
  overview,
}

export enum DirectSaleXFinancialOrderType {
  numberDirectSale,
  employee,
}

export enum DirectSaleXFinancialFilterDateBy {
  sale,
  financial,
}

export enum DirectSaleXFinancialFilterBy {
  sale,
  authorization,
  emission,
  dueDate,
  receipt,
}

export interface QuestReportDirectSaleXFinancialRequest {
  reportType: DirectSaleXFinancialReportType;
  companiesIds?: string;
  employeesIds?: string;
  documentTypesIds?: string;
  orderType?: DirectSaleXFinancialOrderType;
  onlyDirectSellWithNoFinancial?: boolean;
  filterDateBy?: DirectSaleXFinancialFilterDateBy;
  filterBy?: DirectSaleXFinancialFilterBy;
  startDate: string;
  endDate: string;
}

export interface QuestReportDirectSaleXFinancialFormValues {
  reportType: DirectSaleXFinancialReportType;
  companiesIds?: number[];
  employeesIds?: number[];
  documentTypesIds?: number[];
  orderType?: DirectSaleXFinancialOrderType;
  onlyDirectSellWithNoFinancial?: boolean;
  filterDateBy?: DirectSaleXFinancialFilterDateBy;
  filterBy?: DirectSaleXFinancialFilterBy;
  initialDate: Moment;
  finalDate: Moment;
}
